import { useQuery } from "@tanstack/react-query";
import { fetchCountriesWith4A1KData } from "./dataService.api";

export const use4A1KData = () => {
  const { data: countries } = useQuery({
    queryKey: ["get-countries-with-4A1K-data"],
    queryFn: async () => {
      return await fetchCountriesWith4A1KData();
    },
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
  return countries as string[];
};
